import { createStore } from 'vuex'

import modules from './modules'

const store = createStore({
  state : {
    currentUser: JSON.parse(localStorage.getItem('currentUser')),
    selectedEtablissement: safeParse(localStorage.getItem('selectedEtablissement')),
    daterange: localStorage.getItem('daterange'),
    jwt_token: localStorage.getItem('jwt_token'),
    refresh_token: localStorage.getItem('refresh_token'),
    locale: localStorage.getItem('locale')

  },
  modules,

  mutations : {
    SET_SELECTED_RAMIFICATION(state, newValue) {
      state.selectedRamification = newValue
      saveState('setSelectedRamification', newValue)
    },
    SET_JWT_TOKEN(state, newValue) {
      state.jwt_token = newValue
      saveState('setJwtToken', newValue)
    },
    SET_LOCALE(state, newValue) {
      state.locale = newValue
      saveState('setLocale', newValue)
    },
    SET_REFRESH_TOKEN(state, newValue) {
      state.refresh_token = newValue
      saveState('setRefreshToken', newValue)
    },
    SET_SELECTED_CENTRE(state, newValue) {
      state.selectedCentre = newValue
      saveState('setSelectedCentre', newValue)
    },
    SET_SELECTED_CENTRE_DECLARATION(state, newValue) {
      state.selectedCentreDeclaration = newValue
      saveState('setSelectedCentreDeclaration', newValue)
    },
    SET_CURRENT_USER(state, newValue) {
      state.currentUser = newValue
      saveState('currentUser', newValue)
    },
    SET_DATERANGE(state, newValue) {
      state.daterange = newValue
      saveState('setDaterange', newValue)
    },
    SET_USER_ENTITES(state, newValue) {
      state.userEntites = newValue
      saveState('setUserEntites', newValue)
    },
    SET_USER_RAMIFICATIONS(state, newValue) {
      state.userRamifications = newValue
      saveState('setUserRamifications', newValue)
    },
    SET_DASHBOARD_STATS(state, newValue) {
      state.dasboardStats = newValue
      saveState('dasboardStats', newValue)
    },
    SET_SELECTED_ETABLISSEMENT(state, newValue) {
      state.selectedEtablissement = newValue
      saveState('selectedEtablissement', newValue)
    },
    SET_SELECTED_ANNEE(state, newValue) {
      state.selectedAnnee = newValue
      saveState('setAnnee', newValue)

    },

  },
  getters : {
    // Whether the user is currently logged in.
    loggedIn(state) {
      return !!state.currentUser
    },

  },
  actions : {
    // This is automatically run in `src/state/store.js` when the app
    // starts, along with any other actions named `init` in other modules.
    // eslint-disable-next-line no-unused-vars

    setDaterange({ commit }, daterange) {
      commit('SET_DATERANGE', daterange)
    },
    setLocale({ commit }, locale) {
      commit('SET_LOCALE', locale)
    },
    setJwtToken({ commit }, token) {
      commit('SET_JWT_TOKEN', token)
    },
    setRefreshToken({ commit }, token) {
      commit('SET_REFRESH_TOKEN', token)
    },


    // Logs in the current user.
    logIn({ commit }, user= {}) {
      commit('SET_CURRENT_USER', user)
    },

    setSelectedEtablissement({ commit }, etablissement) {

      commit('SET_SELECTED_ETABLISSEMENT', etablissement)
    },
  },
  strict: process.env.NODE_ENV !== 'production',
})

export default store

function saveState(key, state) {
  window.sessionStorage.setItem(key, JSON.stringify(state))
}
function safeParse(value) {
  try {
    if (!value || value === "undefined") return null
    return JSON.parse(value)
  } catch (e) {
    console.warn("Erreur de parsing JSON :", value)
    return null
  }
}